import { createSelector } from 'reselect';

const selectConversationsRoot = (state) => state.conversations;
const selectConversations = (state) =>
  selectConversationsRoot(state).conversations;
const selectMessages = (state) => selectConversationsRoot(state).messages;

export const selectInbox = (state) => selectConversationsRoot(state).inbox;
export const selectPending = (state) => selectConversationsRoot(state).pending;
export const selectArchived = (state) =>
  selectConversationsRoot(state).archived;
export const selectSent = (state) => selectConversationsRoot(state).sent;

export const selectConversation = (inboxId, contactHash) => (state) =>
  selectConversations(state).entities[`${inboxId}:${contactHash}`];

export const selectMessagesForId = (key) => (state) =>
  selectMessages(state)[key];

export const selectMessageLoading = (state) => selectMessages(state).loading;

export const selectInboxConversations = createSelector(
  [selectInbox, selectConversations],
  (inbox, { entities }) => {
    const items = inbox.ids.map((id) => entities[id]).filter(Boolean);
    return {
      ...inbox,
      data: items,
    };
  },
);

export const selectArchivedConversations = createSelector(
  [selectArchived, selectConversations],
  (inbox, { entities }) => {
    const items = inbox.ids.map((id) => entities[id]).filter(Boolean);
    return {
      ...inbox,
      data: items,
    };
  },
);

export const selectPendingMessages = selectPending;
export const selectPendingMessage = (id) => (state) => {
  const { data } = selectPending(state);
  return data.find((i) => i.hash === id);
};

export const selectSentMessages = selectSent;
export const selectSentMessage = (id) => (state) => {
  const { data } = selectSent(state);
  return data.find((i) => i.hash === id);
};

export const selectUnreadCount = (state) =>
  selectConversations(state).inboxes.reduce(
    (acc, i) => acc + Number(i.num_unread),
    0,
  );
export const selectUnreadArchivedCount = (state) =>
  selectArchived(state).unread;

export const selectSelectedInbox = (state) =>
  selectConversations(state).selectedInbox;
